import { z } from "zod";

export const zodBooleanCoerce = z.preprocess((val) => {
  if (typeof val === "string") {
    const v = val.trim().toLowerCase();
    if (["true", "1", "yes", "on"].includes(v)) return true;
    if (["false", "0", "no", "off", ""].includes(v)) return false;
  }
  return val; // pass through if already boolean or unset
}, z.boolean());
